import rootWrapper from "./rootWrapper"
export const wrapRootElement = rootWrapper
